// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".integrations-view .loading-component{border-radius:6px}.integrations-view .card-component__header{border-bottom:none}.integrations-view .card-component__content{padding:0}", ""]);
// Exports
module.exports = exports;
